import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { VpButton } from '../../components';
import VpMediaInfoMenu from '../../widgets/VpMediaTable/VpMediaInfoMenu';
import VpAttachmentInfoMenu from '../../widgets/VpMediaTable/VpAttachmentInfoMenu';
import VpMediaInfoPreview from './VpMediaInfoPreview';
import VpMediaInfoDetails from './VpMediaInfoDetails';

const boxStyles = {
  flex: 1,
  padding: '25px'
};
const stackStyles = {
  height: '100%'
};
const buttonStyles = {
  width: 60
};
const menuBoxStyles = {
  marginInlineStart: 'auto'
};

export const VpMediaInfo = ({ media }) => {
  const isVideo = !!media?.mediaId;
  const mediaId = media?.mediaId || media?.attachmentId;
  const [isShowingDetails, setIsShowingDetails] = useState(false);

  const handleClick = (value) => {
    setIsShowingDetails(value);
  };

  const calculateProps = (compareValue) =>
    compareValue === isShowingDetails
      ? {
          color: 'info',
          variant: 'contained'
        }
      : {
          color: 'neutral'
        };

  return (
    <Box sx={boxStyles}>
      <Stack gap={5} sx={stackStyles}>
        <Stack direction="row" alignItems="center" gap={1} justifyContent="space-between">
          <VpButton onClick={() => handleClick(false)} sx={buttonStyles} {...calculateProps(false)}>
            Preview
          </VpButton>
          <VpButton onClick={() => handleClick(true)} sx={buttonStyles} {...calculateProps(true)}>
            Details
          </VpButton>
          <Box sx={menuBoxStyles}>
            {isVideo ? <VpMediaInfoMenu media={media} /> : <VpAttachmentInfoMenu media={media} />}
          </Box>
        </Stack>
        {isShowingDetails ? (
          <VpMediaInfoDetails key={mediaId} media={media} />
        ) : (
          <VpMediaInfoPreview key={mediaId} media={media} />
        )}
      </Stack>
    </Box>
  );
};

VpMediaInfo.propTypes = {
  media: PropTypes.shape({
    mediaId: PropTypes.string,
    attachmentId: PropTypes.string
  })
};

export default VpMediaInfo;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfo.jsx